<template>
  <card>
    <div class="filter-grid disable-ske TableProductFilters">
      <div>
        <span>Sku</span>
        <TableSearchField
          :value="sku"
          @input="(val) => $emit('update:sku', val)"
        />
      </div>

      <div>
        <span>Korte beschrijving</span>
        <TableSearchField
          :value="short_description"
          @input="(val) => $emit('update:short_description', val)"
        />
      </div>

      <div>
        <span>Beschrijving</span>
        <TableSearchField
          :value="description"
          @input="(val) => $emit('update:description', val)"
        />
      </div>

      <div>
        <span>URL</span>
        <TableSearchField
          :value="url"
          @input="(val) => $emit('update:url', val)"
        />
      </div>

      <div>
        <span>Aanbevolen verkoopprijs</span>
        <div class="d-flex w-100">
          <div class="min-max-original-field">
            <TableSearchField
              :value="recommended_retail_price"
              @input="(val) => $emit('update:recommended_retail_price', val)"
            />
          </div>

          <div class="min-max-filter mx-1">
            <TableSearchField
              :value="min_recommended_retail_price"
              @input="
                (val) => $emit('update:min_recommended_retail_price', val)
              "
              placeholder="Min"
            />
          </div>

          <div class="min-max-filter">
            <TableSearchField
              :value="max_recommended_retail_price"
              @input="
                (val) => $emit('update:max_recommended_retail_price', val)
              "
              placeholder="Max"
            />
          </div>
        </div>
      </div>

      <div>
        <span>Aanbieding prijs</span>
        <div class="d-flex w-100">
          <div class="min-max-original-field">
            <TableSearchField
              :value="special_price"
              @input="(val) => $emit('update:special_price', val)"
            />
          </div>

          <div class="min-max-filter mx-1">
            <TableSearchField
              :value="min_special_price"
              @input="(val) => $emit('update:min_special_price', val)"
              placeholder="Min"
            />
          </div>

          <div class="min-max-filter">
            <TableSearchField
              :value="max_special_price"
              @input="(val) => $emit('update:max_special_price', val)"
              placeholder="Max"
            />
          </div>
        </div>
      </div>

      <div>
        <span>Koop prijs</span>
        <div class="d-flex w-100">
          <div class="min-max-original-field">
            <TableSearchField
              :value="buy_price"
              @input="(val) => $emit('update:buy_price', val)"
            />
          </div>

          <div class="min-max-filter mx-1">
            <TableSearchField
              :value="min_buy_price"
              @input="(val) => $emit('update:min_buy_price', val)"
              placeholder="Min"
            />
          </div>

          <div class="min-max-filter">
            <TableSearchField
              :value="max_buy_price"
              @input="(val) => $emit('update:max_buy_price', val)"
              placeholder="Max"
            />
          </div>
        </div>
      </div>

      <div>
        <span>Groothandel Prijs</span>
        <div class="d-flex">
          <div class="min-max-original-field">
            <TableSearchField
              :value="wholesale_price"
              @input="(val) => $emit('update:wholesale_price', val)"
            />
          </div>

          <div class="min-max-filter mx-1">
            <TableSearchField
              :value="min_wholesale_price"
              @input="(val) => $emit('update:min_wholesale_price', val)"
              placeholder="Min"
            />
          </div>

          <div class="min-max-filter">
            <TableSearchField
              :value="max_wholesale_price"
              @input="(val) => $emit('update:max_wholesale_price', val)"
              placeholder="Max"
            />
          </div>
        </div>
      </div>

      <div>
          <span>Groothandel Voorraad</span>
          <div class="d-flex">
            <div class="min-max-original-field">
              <TableSearchField
                :value="wholesale_stock"
                @input="(val) => $emit('update:wholesale_stock', val)"
              />
            </div>

            <div class="min-max-filter mx-1">
              <TableSearchField
                :value="min_wholesale_stock"
                @input="(val) => $emit('update:min_wholesale_stock', val)"
                placeholder="Min"
              />
            </div>
            <div class="min-max-filter">
              <TableSearchField
                :value="max_wholesale_stock"
                @input="(val) => $emit('update:max_wholesale_stock', val)"
                placeholder="Max"
              />
            </div>
          </div>
      </div>

      <div>
        <span>Belasting</span>
        <TableSearchField
          :value="tax"
          @input="(val) => $emit('update:tax', val)"
        />
      </div>

      <div>
        <span>Ean 13</span>
        <TableSearchField
          :value="ean13"
          @input="(val) => $emit('update:ean13', val)"
        />
      </div>

      <div>
        <span>Wholesale Ean</span>
        <TableSearchField
          :value="wholesale_ean"
          @input="(val) => $emit('update:wholesale_ean', val)"
        />
      </div>

      <div>
        <span>Productvoorraad</span>
        <div class="d-flex">
            <div class="min-max-original-field">
            <TableSearchField
              :value="product_stock"
              @input="(val) => $emit('update:product_stock', val)"
            />
          </div>

          <div class="min-max-filter mx-1">
            <TableSearchField
              :value="min_product_stock"
              @input="(val) => $emit('update:min_product_stock', val)"
              placeholder="Min"
            />
          </div>

          <div class="min-max-filter">
            <TableSearchField
              :value="max_product_stock"
              @input="(val) => $emit('update:max_product_stock', val)"
              placeholder="Max"
            />
          </div>
        </div>
      </div>

      <div class="">
        <span class="label input-label d-flex align-items-center">
          Merk
        </span>
        <CheckboxOptions
        endpoint="/api/brands"
        placeholder="Zoek merk..."
        :selected.sync="brands"
        :page-size=100
        label="Merk"
        item-name="name"
        >
          <span class="checkbox-label">
            Zoek merk...
          </span>

          <template #end-of-list="{ close }">
            <div class="d-flex">
              <button class="mx-2 btn btn-primary flex-grow-1" @click="$event => assignBrands(close)">
                Opslaan
              </button>
            </div>
          </template>
        </CheckboxOptions>
      </div>

      <div class="">
        <span class="label input-label d-flex align-items-center">
          Leverancier
        </span>
        <CheckboxOptions
        endpoint="/api/suppliers"
        :selected.sync="suppliers"
        placeholder="Zoek leverancier..."
        search-query="name"
        label="Leverancier"
        item-name="name"
        >
          <span class="checkbox-label">
            Zoek leverancier...
          </span>

          <template #end-of-list="{ close }">
            <div class="d-flex">
              <button class="mx-2 btn btn-primary flex-grow-1" @click="$event => assignSuppliers(close)">
                Opslaan
              </button>
            </div>
          </template>
        </CheckboxOptions>
      </div>

      <div class="">
        <span class="label input-label d-flex align-items-center">
          Categorie
        </span>
        <CheckboxOptions
        endpoint="/api/categories"
        :selected.sync="categories"
        search-query="category"
        placeholder="Zoek Categorie..."
        label="Category"
        item-name="category"
        >
          <span class="checkbox-label">
            Zoek Categorie...
          </span>

          <template #end-of-list="{ close }">
            <div class="d-flex">
              <button class="mx-2 btn btn-primary flex-grow-1" @click="$event => assignCategories(close)">
                Opslaan
              </button>
            </div>
          </template>
        </CheckboxOptions>
      </div>
    </div>
  </card>
</template>

<script>
import FormInput from "../Inputs/FormInput.vue";
import TableSearchField from "../Inputs/TableSearchField.vue";
import CheckboxOptions from "../../layout/Table/DropdownCheckboxTableFilters/CheckboxOptions.vue"
import FormSearchSelector from "../Inputs/FormSearchSelector.vue";
import ProductListItem from "./ProductListItem.vue";

export default {
  props: {
    sku: String,
    short_description: String,
    description: String,
    url: String,
    tax: String,
    ean13: String,
    wholesale_ean: String,
    width: String,
    height: String,
    depth: String,
    weight: String,

    buy_price: String,
    min_buy_price: [Number, String],
    max_buy_price: [Number, String],

    special_price: [Number, String],
    min_special_price: [Number, String],
    max_special_price: [Number, String],

    recommended_retail_price: [Number, String],
    min_recommended_retail_price: [Number, String],
    max_recommended_retail_price: [Number, String],

    wholesale_price: [Number, String],
    min_wholesale_price: [Number, String],
    max_wholesale_price: [Number, String],

    wholesale_stock: [Number, String],
    min_wholesale_stock: [Number, String],
    max_wholesale_stock: [Number, String],

    product_stock: [Number, String],
    min_product_stock: [Number, String],
    max_product_stock: [Number, String],

    supplier: Array,
    category: Array,
    brand: Array,
  },
  components: {
    ProductListItem,
    FormSearchSelector,
    FormInput,
    TableSearchField,
    CheckboxOptions
  },
  data () {
    return {
      categories: [],
      suppliers: [],
      brands: []
    }
  },
  created(){
    this.categories = this.getFromLocalStorage('categories-multi-select-catalogs-filter')
    this.suppliers = this.getFromLocalStorage('suppliers-multi-select-catalogs-filter')
    this.brands = this.getFromLocalStorage('brands-multi-select-catalogs-filter')
  },
  computed: {
    fields() {
      return Object.keys(this.$props);
    },
  },
  methods: {
    assignCategories(close) {
      this.storeToLocalStorage('categories-multi-select-catalogs-filter', this.categories)
      const ctgs = this.categories.map(ctg => ctg.uid)
      this.$emit('update:category', ctgs)
      close && close()
    },
    assignSuppliers(close) {
      this.storeToLocalStorage('suppliers-multi-select-catalogs-filter', this.suppliers)
      const spls = this.suppliers.map(spl => spl.uid)
      this.$emit('update:supplier', spls)
      close && close()
    },
    assignBrands(close) {
      this.storeToLocalStorage('brands-multi-select-catalogs-filter', this.brands)
      const brnds = this.brands.map(brnd => brnd.uid)
      this.$emit('update:brand', brnds)
      close && close()
    },
    storeToLocalStorage(key, val) {
      localStorage.setItem(key, JSON.stringify(val))
    },
    getFromLocalStorage(key) {
      const data = localStorage.getItem(key)
      if (data) return JSON.parse(data)
      return []
    }
  }
};
</script>

<style>
.checkbox-label {
  color: #999999;
}

.TableProductFilters .search-selector .label {
  font-weight: 400 !important;
  font-size: 0.875rem !important;
  text-transform: initial !important;
  padding: 0.25rem 0.5rem !important;
  padding-left: 0px !important;
}

.TableProductFilters .search-selector input {
  border-radius: 3px !important;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
  margin: 0px;
  height: 31px !important;
}

.TableProductFilters .search-selector {
  margin-top: -1px;
}
</style>

<style scoped>

.min-max-filter {
  width: 55px;
}

.min-max-original-field {
  flex-grow: 1;
}

.filter-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  gap: 12px;
  margin: 12px;
}

@media (max-width: 1300px) {
  .filter-grid {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
}

@media (max-width: 1100px) {
  .filter-grid {
    grid-template-columns: 1fr 1fr 1fr;
  }
}

@media (max-width: 700px) {
  .filter-grid {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 500px) {
  .filter-grid {
    grid-template-columns: 1fr;
  }
}
</style>
